import React, { useState } from 'react';
import usePageMeta from '../hooks/usePageMeta';

const cities = [
    {
        id: 'hyderabad',
        name: 'Hyderabad',
        state: 'Telangana',
        tagline: 'Our Home City – Where Excellence Began',
        hero: '/images/Hyderabad.jpg',
        desc: 'As the birthplace of Bliv Design Studio, Hyderabad is where our design philosophy was shaped. We have delivered 350+ luxury interior projects across Hyderabad\'s most prestigious residential addresses including Jubilee Hills, Banjara Hills, Gachibowli, Kondapur, and Madhapur.',
        highlights: ['350+ Projects', 'All Pin Codes', '5-Star Rated'],
        projects: ['Bluewood 3BHK – Gachibowli', 'Velora 3BHK – Kondapur', 'Prestige High Fields – Kukatpally'],
        icon: '🏙️',
        available: true,
    },
    {
        id: 'bangalore',
        name: 'Bangalore',
        state: 'Karnataka',
        tagline: 'Powering Silicon Valley Homes',
        hero: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=1200&q=85',
        desc: 'Bangalore\'s cosmopolitan lifestyle demands interiors that are as dynamic as the city itself. Our Bangalore team works across Whitefield, Electronic City, Koramangala, Indiranagar and HSR Layout — creating tech-savvy, design-forward homes for IT professionals and families alike.',
        highlights: ['80+ Projects', 'All Major Areas', 'Fast Execution'],
        projects: ['Ocean View Duplex – Whitefield', 'Smart 3BHK – Koramangala', 'Luxury Villa – Sarjapur'],
        icon: '💻',
        available: true,
    },
    {
        id: 'vizag',
        name: 'Vizag',
        state: 'Andhra Pradesh',
        tagline: 'Coastal Luxury Redefined',
        hero: '/images/Vizag.jpg',
        desc: 'In the City of Destiny, we bring coastal-inspired luxury to life. From ocean-view penthouses to modern apartments, our Vizag team delivers premium interiors that blend comfort with the city\'s majestic vibes.',
        highlights: ['60+ Projects', 'Full City Coverage', 'Local Expertise'],
        projects: ['Sea-View Penthouse – MVP Colony', 'Modern 3BHK – Gajuwaka', 'Luxury Flat – Rushikonda'],
        icon: '⚓',
        available: true,
    },
    {
        id: 'vijayawada',
        name: 'Vijayawada',
        state: 'Andhra Pradesh',
        tagline: 'Traditional Elegance, Modern Living',
        hero: 'https://images.unsplash.com/photo-1669749574067-47292593811f?w=1200&q=85',
        desc: 'Serving the commercial heart of Andhra Pradesh, our Vijayawada team specializes in creating spaces that honor tradition while embracing modern luxury. We provide end-to-end solutions for villas and apartments across the city.',
        highlights: ['45+ Projects', 'Rapid Delivery', 'Award Winning'],
        projects: ['Luxury Villa – Benz Circle', 'Modern Apartment – Patamata', 'Premium Flat – Kanuru'],
        icon: '🏛️',
        available: true,
    },

    {
        id: 'nizamabad',
        name: 'Nizamabad',
        state: 'Telangana',
        tagline: 'Quality Interiors for the City of Lakes',
        hero: 'https://plus.unsplash.com/premium_photo-1673240845266-2f2c432cf194?w=1200&q=85',
        desc: 'Expanding our footprint in Telangana, our Nizamabad team brings the same level of excellence and premium finish that Bliv is known for. We serve all major residential ventures in and around Nizamabad.',
        highlights: ['20+ Projects', 'Dedicated Team', 'Local Presence'],
        projects: ['Modern 3BHK Flat', '2BHK Apartment Interior', 'Independent House Project'],
        icon: '🏠',
        available: true,
    },
    {
        id: 'puttaparthi',
        name: 'Puttaparthi',
        state: 'Andhra Pradesh',
        tagline: 'Peaceful Designs for a Spiritual Hub',
        hero: '/images/Puttaparthi.png',
        desc: 'Serving the serene town of Puttaparthi, we offer specialized interior solutions that reflect peace and elegance. Our team is equipped to handle premium projects for residents and visiting devotees.',
        highlights: ['15+ Projects', 'Custom Furniture', 'Reliable Service'],
        projects: ['Spiritual Home Interior', '2BHK Apartment', 'Guest House Project'],
        icon: '🕉️',
        available: true,
    },
    {
        id: 'anantapur',
        name: 'Anantapur',
        state: 'Andhra Pradesh',
        tagline: 'Modernizing Homes in Anantapuram',
        hero: 'https://images.unsplash.com/photo-1600367628496-9c6b654e2fac?w=1200&q=85',
        desc: 'Our Anantapur team is dedicated to bringing modern, functional, and beautiful interior designs to the growing city. From modular kitchens to full home transformations, we do it all.',
        highlights: ['18+ Projects', 'Professional Finish', 'On-time Delivery'],
        projects: ['3BHK Flat – City Center', 'Modular Kitchen – Housing Board', 'Living Room Makeover'],
        icon: '🏘️',
        available: true,
    },
    {
        id: 'rajahmundry',
        name: 'Rajahmundry',
        state: 'Andhra Pradesh',
        tagline: 'Royal Designs for the Cultural Capital',
        hero: 'https://images.unsplash.com/photo-1692228248658-dd0aea8e7bfe?w=1200&q=85',
        desc: 'In the cultural capital of Andhra Pradesh, we offer "Royal" interior designs that blend the city\'s heritage with modern luxury. We serve Rajahmundry and surrounding Godavari districts.',
        highlights: ['25+ Projects', 'Godavari Style', 'Premium Materials'],
        projects: ['River View Apartment', 'Traditional Style Villa', 'Modern 3BHK Interior'],
        icon: '🌊',
        available: true,
    },
];


const services = ['Modular Kitchen', 'Wardrobe Design', 'Living Room', 'Bedroom Design', 'False Ceiling', 'Bathroom Design', 'Full Home Interior'];

export default function CitiesPage() {
    const [activeCity, setActiveCity] = useState(null);

    usePageMeta(
        'Top Interior Designers in South India | Bliv Design Studio',
        'Bliv Design Studio offers home interior design services in Hyderabad, Nizamabad, Bangalore, Vizag, Puttaparthi, Anantapur, Vijayawada, and Rajahmundry.'
    );

    if (activeCity) {
        const city = cities.find(c => c.id === activeCity);
        return (
            <>
                {/* City Detail Hero */}
                <section className="relative pt-36 pb-0">
                    <div className="absolute inset-0 h-96">
                        <img src={city.hero} alt={city.name} className="w-full h-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30" />
                    </div>
                    <div className="relative max-w-7xl mx-auto px-4 pt-4 pb-0 text-center">
                        <button onClick={() => setActiveCity(null)} className="text-white/70 hover:text-white text-sm mb-4 inline-flex items-center gap-1 transition-colors">
                            ← All Cities
                        </button>
                        <div className="text-5xl mb-3">{city.icon}</div>
                        <h1 className="text-5xl md:text-6xl font-bold text-white mb-3">{city.name}</h1>
                        <p className="text-[#2E63E8] font-semibold text-base">{city.tagline}</p>
                    </div>
                </section>

                <section className="section-pad bg-white">
                    <div className="max-w-7xl mx-auto px-4">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                            {/* Main content */}
                            <div className="lg:col-span-2">
                                <div className="flex gap-4 mb-8">
                                    {city.highlights.map((h, i) => (
                                        <div key={i} className="bg-[#f0f4fe] rounded-xl px-5 py-3 text-center">
                                            <div className="text-[#2E63E8] font-bold text-sm">{h}</div>
                                        </div>
                                    ))}
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">Interior Design in {city.name}, {city.state}</h2>
                                <p className="text-gray-600 leading-relaxed mb-8 text-base">{city.desc}</p>

                                {/* Projects in city */}
                                <h3 className="text-xl font-bold text-gray-900 mb-4">Featured Projects in {city.name}</h3>
                                <div className="space-y-3">
                                    {city.projects.map((proj, i) => (
                                        <div key={i} className="flex items-center gap-3 bg-gray-50 rounded-xl px-5 py-3.5">
                                            <span className="w-8 h-8 bg-[#2E63E8] rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                                                {i + 1}
                                            </span>
                                            <span className="text-gray-800 font-medium">{proj}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Sidebar */}
                            <div>
                                <div className="bg-[#0D0D0D] rounded-2xl p-6 text-white mb-6 sticky top-32">
                                    <h3 className="font-bold text-lg mb-4">Services in {city.name}</h3>
                                    <ul className="space-y-2 mb-6">
                                        {services.map((s, i) => (
                                            <li key={i} className="flex items-center gap-2 text-sm text-gray-300">
                                                <span className="w-1.5 h-1.5 bg-[#2E63E8] rounded-full flex-shrink-0"></span>
                                                {s}
                                            </li>
                                        ))}
                                    </ul>
                                    <a href="/contact" className="btn-yellow w-full block text-center text-sm py-3">
                                        Get Free Estimate in {city.name}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <>
            {/* Hero */}
            <section className="relative pt-36 pb-24 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#0A1128] via-[#1C2541] to-[#0D0D0D]" />
                <div className="relative max-w-7xl mx-auto px-4 text-center">
                    <span className="inline-block bg-[#2E63E8]/20 border border-[#2E63E8]/40 text-[#2E63E8] text-xs font-semibold px-5 py-2 rounded-full mb-5 uppercase tracking-widest">
                        Service Locations
                    </span>
                    <h1 className="text-5xl md:text-7xl font-bold text-white mb-5">Cities We Serve</h1>
                    <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                        Delivering luxury interior design across South India's most vibrant cities. World-class design, local expertise.
                    </p>
                </div>
            </section>

            {/* City Cards */}
            <section className="section-pad bg-white">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {cities.map((city, i) => (
                            <button
                                key={city.id}
                                onClick={() => setActiveCity(city.id)}
                                className={`text-left card-hover rounded-3xl overflow-hidden shadow-md border border-gray-100 group bg-white
                  ${i === 0 ? 'md:col-span-2 lg:col-span-1' : ''}`}
                            >
                                {/* City Image */}
                                <div className="relative h-56 overflow-hidden">
                                    <img src={city.hero} alt={city.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                                    <div className="absolute bottom-4 left-4 flex items-center gap-2">
                                        <span className="text-3xl">{city.icon}</span>
                                        <div>
                                            <p className="text-white font-bold text-xl">{city.name}</p>
                                            <p className="text-gray-300 text-xs">{city.state}</p>
                                        </div>
                                    </div>
                                    <div className="absolute top-3 right-3 bg-[#2E63E8] text-white text-xs font-bold px-3 py-1 rounded-full">
                                        {city.highlights[0]}
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="p-5">
                                    <p className="text-[#2E63E8] font-semibold text-xs mb-2">{city.tagline}</p>
                                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">{city.desc}</p>
                                    <div className="flex items-center gap-1 text-[#2E63E8] font-bold text-sm mt-4 group-hover:gap-2 transition-all">
                                        Explore {city.name} Projects
                                        <span>→</span>
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="bg-[#f0f4fe] py-16 px-4">
                <div className="max-w-2xl mx-auto text-center">
                    <h3 className="text-3xl font-bold text-gray-900 mb-3">Don't See Your City?</h3>
                    <p className="text-gray-600 mb-8">We are expanding rapidly. Contact us today and we'll let you know when we launch in your city — or connect you with our nearest design studio.</p>
                    <a href="/contact" className="btn-yellow inline-block px-10 py-4">Enquire About Your City</a>
                </div>
            </section>
        </>
    );
}
